module.exports = "<symbol id=\"tt-icon-vote-off\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.34 2.34 0 0 1-2.33 2.33H2.62a2.34 2.34 0 0 1-2.33-2.36s6.81-9.48 10.29-14a1.8 1.8 0 0 1 3.13.03zm-11.08 14h18.74L12 6.64z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/vote-off.svg
// module id = 233
// module chunks = 9